import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import healthIssueService from "../../services/heatlh-issue-service";
import Skeleton from 'react-loading-skeleton'
import { SearchOutlined } from "@ant-design/icons";
import { Card, Form, Pagination, Spin, Table, Button, Input, Divider } from "antd";
import { ToastContainer, toast } from 'react-toastify';

const AdminHealthIssues = () => {
  let navigate = useNavigate();
  const [list, setList] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showSave, setShowSave] = useState(true);




  ////TODO ESTO ES DE PAGINACION/////////

  const [findName, setFindName] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(8);
  const [total, setTotal] = useState(0);

  const handlePageChange = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
  };




  const statesList = [
    { id: true, name: "ACTIVO" },
    { id: false, name: "INACTIVO" },
  ];

  const yesNoList = [
    { id: true, name: "SI" },
    { id: false, name: "NO" },
  ];

  const listTypes = [
    { id: "PLAGA", name: "PLAGA" },
    { id: "ENFERMEDAD", name: "ENFERMEDAD" },
    { id: "ANOMALIA", name: "ANOMALIA" }
  ];

  const listActions = [
    { id: "SIN_ACCION", name: "SIN ACCION" },
    { id: "FISICO", name: "FISICO" },
    { id: "QUIMICO", name: "QUIMICO" },
    { id: "MIXTO", name: "MIXTO" }
  ];


  const listResults = [
    { id: "SIN_RESULTADO", name: "SIN RESULTADO" },
    { id: "RESUELTO", name: "RESUELTO" },
    { id: "TRATAMIENTO", name: "INICIAR TRATAMIENTO" },
    { id: "ERRADICAR", name: "ERRADICAR PALMA" }
  ];


  const {
    control,
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();


  const searchByName = (e) => {
    const name = e.target.value
    setFindName(name)
  }

  const capitalizeWords = (e) => {
    let value = e.target.value;
    value = value
      .split(' ') // Divide el texto en palabras
      .map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitaliza la primera letra de cada palabra
      )
      .join(' ');
    setValue("name", value);
  };




  ////FUNCIONES QUE USAN EL SERVICIO FARMSERVICE
  ////FUNCIONES QUE USAN EL SERVICIO FARMSERVICE
  const getListByName = async () => {
    setLoading(true)
    const initPage = 1
    setPage(1)
    const response = await healthIssueService.getListPagination(initPage, pageSize, findName);
    if (response)
      setList(response.data);
    setTotal(response.total);
    setLoading(false)
  };


  
  const getList = async () => {
    setLoading(true)
    //const initPage = 1
    //setPage(1)
    const response = await healthIssueService.getListPagination(page, pageSize, findName);
    if (response)
      setList(response.data);
    setTotal(response.total);
    setLoading(false)
  };

  const updateHealthIssue = async () => {
    const data = getValues();
    const success = await healthIssueService.update(data);
    if (success) {
      reset();
      getList();
      setShowEdit(false);
      setShowSave(true);
      toast('Realizado.', { autoClose: 1000 });
    }
  };

  const customSubmit = async () => {
    const data = getValues();
    const response = await healthIssueService.insert(data);
    if (response.success) {
      reset();
      getList();
      toast('Realizado.', { autoClose: 1000 });
    }
    else {
      toast.error(response.message);
    }
  };

  const cancelar = async () => {
    setShowEdit(false);
    setShowSave(true);
    reset();
  };

  const getIssue = async (issueId) => {
    const issue = await healthIssueService.getHealthIssue(issueId);
    if (issue) {
      setValue("id", issue._id);
      setValue("name", issue.name);
      setValue("type", issue.type);
      setValue("hasTreatment", issue.hasTreatment);
      setValue("action", issue.action);
      setValue("result", issue.result);
      setValue("isFinished", issue.isFinished);
      setValue("state", issue.state);
      setShowEdit(true);
      setShowSave(false);

      window.scrollTo({ top: 0, behavior: "smooth" });

    }
  };


  const nameToUpper = (e) => {
    let value = e.target.value.toUpperCase();
    setValue("name", value);
  };

  


  useEffect(() => {
    getList();
  }, [page,pageSize,findName]);

  return (
    <div className="row p-4">
      <ToastContainer />

      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Problemas de sanidad</Divider>
      </div>

      <div className="col-12 col-sm-4">

        <div className="card p-4">
          <form className="form-react"
            onSubmit={handleSubmit(customSubmit)}

          >
            <div className="row">
              <div className="card-title">
                <h4 className="text-secondary" >Datos del problema</h4>
              </div>


              <div className=" col-12 d-none">
                <label>Id issue</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("id")}
                />
              </div>


              <div className=" col-12">
                <label>Nombre</label>
                <input
                  type="text"
                  onKeyUp={nameToUpper}
                  className="form-control"
                  {...register("name", { required: true, minLength: 3 })}
                />
                {errors.name?.type === "required" && (
                  <small className="text-danger">Campo requerido</small>
                )}
                {errors.name?.type === "minLength" && (
                  <small className="text-danger">Minimo 10 caracteres</small>
                )}
              </div>



              <div className=" col-12">
                <label>Tipo</label>
                <select className="form-control" {...register("type")}>
                  {listTypes.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className=" col-12">
                <label>Tiene tratamiento</label>
                <select className="form-control" {...register("hasTreatment")}>
                  {yesNoList.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className=" col-12">
                <label>Acción predefinida</label>
                <select className="form-control" {...register("action")}>
                  {listActions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              

              <div className=" col-12">
                <label>Resultado predefinido</label>
                <select className="form-control" {...register("result")}>
                  {listResults.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>



              <div className=" col-12">
                <label>Finalizado predefinido</label>
                <select className="form-control" {...register("isFinished")}>
                  {yesNoList.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>



              <div className=" col-12">
                <label>Estado</label>
                <select className="form-control" {...register("state")}>
                  {statesList.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className={showEdit ? " col-6" : "d-none"}>
                <label>&nbsp; </label>
                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => updateHealthIssue()}
                >
                  <i className="bi bi-save fa-lg" /> Editar
                </button>
              </div>

              <div className={showSave ? " col-6" : "d-none"}>
                <label>&nbsp; </label>
                <button className="btn btn-primary w-100" type="submit">
                  <i className="bi bi-save fa-lg m-2" /> Guardar
                </button>
              </div>

              <div className=" col-6">
                <label>&nbsp; </label>
                <button
                  className="btn btn-secondary w-100"
                  type="button"
                  onClick={() => cancelar()}
                >
                  <i className="bi bi-x-square fa-lg m-2" /> Cancelar
                </button>
              </div>
            </div>
          </form>
        </div>

      </div>


      <div className="col-12 col-sm-8">
        <div className="card p-4">
          <div className="row">


            <div className="col-4">
              <Input
                prefix={<SearchOutlined className="text-primary" />}
                placeholder={"Nombre"}
                onChange={e => searchByName(e)}
              />
            </div>


            <div className="col-8">
              <Pagination
                className="text-primary "
                current={page}
                pageSize={pageSize}
                total={total}
                onChange={handlePageChange}
                pageSizeOptions={["5", "10", "20", "50"]}
                showTotal={(total) => `Total ${total} items`}
                showSizeChanger
                onShowSizeChange={(current, size) => handlePageChange(1, size)}
              />
            </div>

            <div className="col-12 mt-3">

              <Spin spinning={loading}>
                <div className="bdr">
                  <div className="table-responsive">
                    <table className="table fs-6">
                      <thead className="table-primary">
                        <tr>
                          <th>Nombre</th>
                          <th>Tipo</th>
                          <th>Tto</th>
                          <th>Acción</th>
                          <th>Resultado</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((issue, index) => {                        
                          return (
                            <tr key={index} className={issue.state ? "" : "table-secondary"}  >
                              <td>{issue.name}</td>
                              <td>{issue.type}</td>
                              <td>{issue.hasTreatment?"SI":"NO"}</td>
                              <td>{issue.action}</td>
                              <td>{issue.result}</td>
                              <td style={{ width: "100px" }}>
                                <button
                                  className="btn btn-primary"
                                  onClick={() => getIssue(issue._id)}
                                >
                                  <i className="bi bi-pencil-square fa-lg m-1" /> Editar
                                </button>

                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Spin>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default AdminHealthIssues;
